import { NamedItemInt } from '../common/namedItem'

enum EmailStatus {
  /*
   * Initiated means that we have completed the request on our end, since Sent would mean the client has received the
   * email, however we register emails to the database before we know if it has reached or not. This distinction is
   * important so we do not confuse what happened with the email.
   */
  Initiated,
  FailedToInitiate,
  Delivered,
  Complaint,
  Bounced,
  Created,
}

export default EmailStatus

export const EmailStatuses: NamedItemInt[] = [
  {
    name: 'Created',
    id: EmailStatus.Created,
  },
  {
    name: 'Initiated',
    id: EmailStatus.Initiated,
  },
  {
    name: 'FailedToInitiate',
    id: EmailStatus.FailedToInitiate,
  },
  {
    name: 'Delivered',
    id: EmailStatus.Delivered,
  },
  {
    name: 'Complaint',
    id: EmailStatus.Complaint,
  },
  {
    name: 'Bounced',
    id: EmailStatus.Bounced,
  },
]
